import { openLogoSidebar } from '@UI/Pages/Administration/Organizations/Signals/logoSidebarSignal';
import { requestLogoRemoval } from '@UI/Pages/Administration/Organizations/Signals/logoToRemoveSignal';
import { css } from '@emotion/react';
import * as React from 'react';
import { Button } from '@verclam/ui-kit';

const actionsStyle = css`
	display: flex;
	align-items: center;
	gap: 0.5rem;
	flex-wrap: wrap;
`;

type Props = {
	readonly hasLogo: boolean;
};

/** Leaf actions: they open the sidebar and request the removal confirmation through signal setters. */
const AccountLogoCardActions: React.FC<Props> = ({ hasLogo }) => {
	const handleUploadClick = React.useCallback(() => {
		openLogoSidebar({ owner: 'account' });
	}, []);

	const handleRemoveClick = React.useCallback(() => {
		requestLogoRemoval({ owner: 'account' });
	}, []);

	if (!hasLogo) {
		return (
			<div css={actionsStyle}>
				<Button type="button" label="Déposer un logo" onClick={handleUploadClick} />
			</div>
		);
	}

	return (
		<div css={actionsStyle}>
			<Button type="button" severity="secondary" label="Remplacer" onClick={handleUploadClick} />
			<Button type="button" severity="danger" label="Retirer" onClick={handleRemoveClick} />
		</div>
	);
};

export default AccountLogoCardActions;
